import React from "react";
import "./pageNotFound.css";

const PageNotFound = () => {
  return <div className="page-not-found">404 Page Not Found!</div>;
};

export default PageNotFound;
